<template>
  <footer>
    <b-navbar fixed="bottom" class="shadow-lg" v-if="isFooterVisible">
      <div class="w-100 d-flex justify-content-center">
        <div class="position-relative">
          <b-btn
            variant="none"
            class="msg-general 
            animate__animated 
            animate__infinite 
            animate__slow 
            animate__tada"
            @click="showModalGMsg"
            v-if="jobs.showGlobalMsgIcon"
          >
            <b-iconstack font-scale="3.2">
              <b-icon stacked icon="chat-fill" variant="info"></b-icon>
              <b-icon
                stacked
                icon="cursor-fill"
                variant="white"
                scale="0.6"
              ></b-icon>
            </b-iconstack>
          </b-btn>
          <b-btn @click="setPubMode('CommentForm')" variant="primary">
            Écrire un commentaire</b-btn
          >
        </div>
      </div>
    </b-navbar>
    <b-sidebar
      id="post-msg-sidebar"
      lazy
      no-header-close
      backdrop
      :sidebar-class="
        commentToEdit.mode === 'CommentForm'
          ? 'custom bottom'
          : 'custom bottom answer'
      "
    >
      <div class="container">
        <transition name="slide" mode="out-in">
          <keep-alive>
            <component
              :is="commentToEdit.mode"
              @postSucceded="onPostSucceded"
              @postFailed="onPostFailed"
            ></component>
          </keep-alive>
        </transition>
      </div>
    </b-sidebar>
    <b-sidebar
      v-if="routeIsAnswer"
      id="branch-msg-sidebar"
      lazy
      no-header-close
      backdrop-variant="transparent"
      backdrop
      :visible="showInstructions"
      sidebar-class="custom bottom instuctions"
    >
      <div class="container text-center">
        <template>
          <b-iconstack class="msg-type-icon center" font-scale="2.5">
            <b-icon stacked icon="chat-fill" variant="primary"></b-icon>
            <b-icon
              stacked
              icon="chat"
              variant="primary"
              shift-h="3"
              shift-v="-1"
              flip-h
            ></b-icon>
          </b-iconstack>
        </template>
        <p class="mt-4">
          En répondant à une publication, vous lancez une nouvelle discussion.
        </p>
      </div>
    </b-sidebar>
  </footer>
</template>

<script>
/**
 * @file       Layout deliberation footer component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import CommentForm from "@/modules/comments/components/form.vue";
import MessageForm from "@/modules/comments/components/message.vue";
import { commentsMixin } from "@/modules/comments/mixins";


/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "dlibrFooter",
  components: {
    CommentForm,
    MessageForm
  },
  mixins: [commentsMixin],
  data() {
    return {
      showInstructions: false
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    /**
     * Check if instructions branch should be shown.
     *
     * @return      {Bool}  true or false
     */
    showInstructionsBranch() {
      return (
        this.$route.name == "deliberation.byUrl.answers" &&
        this.comments.status == "success" &&
        this.comments.data.data.length == 0 &&
        !this.isFilter
      );
    },

    /**
     * Check if the footer is visible.
     *
     * @return      {Bool}  true or false
     */
    isFooterVisible() {
      return (
        this.dlibr.status == 1 &&
        this.isStudent &&
        !this.isFilter &&
        (this.$route.name == "deliberation.byUrl" ||
          this.$route.name == "deliberation.byUrl.answers")
      );
    }
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Set pub mode.
     *
     * @param      {Object}  mode     The mode
     */
    setPubMode(mode) {
      this.$store.commit("deliberations/setPubToEdit", {
        pub: {},
        mode
      });
      this.onPostSucceded();
    },

    /**
     * Post succeeded.
     */
    onPostSucceded() {
      this.$root.$emit("bv::toggle::collapse", "post-msg-sidebar");
    },

    /**
     * Post failed.
     */
    onPostFailed() {
      this.$root.$emit("bv::toggle::collapse", "post-msg-sidebar");
    },

    /**
     * Show modal general message.
     */
    showModalGMsg() {
      if (this.isStudent) {
        this.$store.commit("comments/resetGeneralMessages");
        this.$store.commit("comments/setGeneralMsgsFilters", {
          reset: true,
          fields: {
            user: this.profile.id,
            deliberation: this.dlibr.id
          }
        });
        this.$store.dispatch("comments/getGeneralMsgs");
        this.$bvModal.show("generalMessageModal");
      }
    }
  },

  /**
   * Watches.
   * 
   * @type  {Object}
   */
  watch: {
    /**
     * Show instructions branch.
     *
     * @param      {Bool}  value     true to show the instructions
     */
    showInstructionsBranch(value) {
      if (value) {
        this.$nextTick(() => {
          this.showInstructions = true;
          setTimeout(() => {
            this.showInstructions = false;
          }, 4000);
        });
      }
    }
  }
};
</script>

<style lang="scss">
.custom.b-sidebar.instuctions {
  height: 10vh !important;
  min-height: 150px !important;
  width: 100%;
  max-width: 100% !important;
  background-color: #d6fefe !important;
}

.custom.b-sidebar.answer {
  height: 40vh !important;
  min-height: 300px !important;
}

.msg-type-icon.center {
  position: absolute;
  top: -1.5rem;
  left: 48.3%;
  @media (max-width: 450px) {
    left: 42%;
  }
  @media (max-width: 770px) {
    left: 46%;
  }
}

.msg-general {
  position: absolute !important;
  left: -45px;
  top: -40px;
}
</style>
